<template>
  <div class="image-text-swiper">
    <div class="image-text-swiper-box" ref="imageTextSwiperBox">
      <swiper :options="imageTextSwiperOptions" ref="imageTextSwiper">
        <swiper-slide v-for="img in images" :key="Math.random().toString(36).substr(2, 9)">
          <div>
            <img-comp :element="img" :size="size" :alt="img.name"></img-comp>
            <p>{{ img.description }}</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-pagination-wrapper">
      <div class="icon outline image-text-swiper-prev">
        <icon name="chevron-left" scale="1.25"></icon>
      </div>
      <div class="image-text-swiper-pagination" slot="pagination"></div>
      <div class="icon outline image-text-swiper-next">
        <icon name="chevron-right" scale="1.25"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'imageSlider',
    props: {
      images: {
        type: Array
      },
      size: {
        type: String,
        default: 'l'
      }
    },
    mixins: [helpers, formatting],
    created () {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      this.setImageTextSwiperWidth()
    },
    data () {
      return {
        imageTextSwiperWidth: null,
        imageTextSwiperOptions: {
          loop: true,
          init: false,
          slidesPerView: 'auto',
          spaceBetween: 30,
          pagination: {
            el: '.image-text-swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.image-text-swiper-next',
            prevEl: '.image-text-swiper-prev'
          },
          breakpoints: {
            1300: {
              spaceBetween: 20
            },
            713: {
              spaceBetween: 10
            }
          }
        }
      }
    },
    methods: {
      setImageTextSwiperWidth () {
        if (document.body.clientWidth > 1300) {
          this.imageTextSwiperWidth = document.body.clientWidth - 220 - (document.body.clientWidth - 1300) / 2
          this.$refs.imageTextSwiperBox.style.width = this.imageTextSwiperWidth + 'px'
          this.$refs.imageTextSwiper.swiper.init()
        } else if (document.body.clientWidth > 712) {
          this.imageTextSwiperWidth = document.body.clientWidth - 105 - (document.body.clientWidth - 712) / 2
          this.$refs.imageTextSwiperBox.style.width = this.imageTextSwiperWidth + 'px'
          this.$refs.imageTextSwiper.swiper.init()
        } else {
          this.$refs.imageTextSwiper.swiper.init()
        }
      },
      handleResize () {
        if (document.body.clientWidth > 1300) {
          this.imageTextSwiperWidth = document.body.clientWidth - 220 - (document.body.clientWidth - 1300) / 2
          this.$refs.imageTextSwiperBox.style.width = this.imageTextSwiperWidth + 'px'
          this.$refs.imageTextSwiper.swiper.update()
        } else if (document.body.clientWidth > 712) {
          this.imageTextSwiperWidth = document.body.clientWidth - 105 - (document.body.clientWidth - 712) / 2
          this.$refs.imageTextSwiperBox.style.width = this.imageTextSwiperWidth + 'px'
          this.$refs.imageTextSwiper.swiper.update()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/slider/imageTextSlider.vue